import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import Slider from "react-slick";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

import Khyzhnyak from "../../img/speaker-quotes/Antonina_Khyzhnyak.webp";
import Naumov from "../../img/speaker-quotes/Serhii_Naumov.webp";
import Tatarchuk from "../../img/speaker-quotes/Valery_Tatarchuk.webp";
import Kepler from "../../img/speaker-quotes/Tata_Kepler.webp";
import Yudina from "../../img/speaker-quotes/Yulia_Yudina.webp";
import Klyatskin from "../../img/speaker-quotes/Yuri_Klyatskin.webp";
import Antipov from "../../img/speaker-quotes/Vladyslav_Antipov.webp";
import Martynchuk from "../../img/speaker-quotes/Serhii_Martynchuk.webp";
import Sakhno from "../../img/speaker-quotes/Valentina_Sakhno.webp";
import Tereshchenko from "../../img/speaker-quotes/Svitlana_Tereshchenko.webp";
import Ivanenko from "../../img/speaker-quotes/Vlad_Ivanenko.webp";


function Quotes() {
    const sliderRef = React.useRef(null);

    const quotesContent = [
        
        {
            name: "Сергій Наумов",
            position: "голова правління АТ Ощадбанк",
            img: Naumov,
            text: "«Війна показала неймовірну стресостійкість жінок. Приклади наших керівниць у прифронтових зонах доводять: жінки здатні показувати рекордні результати в найскладніших обставинах»"
        },
        {
            name: "Валерія Татарчук",
            position: "засновниця БФ «ТВОЯ ОПОРА»",
            img: Tatarchuk,
            text: "«Ми за 20 хвилин зібрали гроші на операцію, і я подумала: якщо це так працює, значить, можна робити більше»"
        },
        {
            name: "Тата Кеплер",
            position: "громадська діячка, волонтерка, засновниця благодійного проєкту «Птахи» БФ «Відчуй»",
            img: Kepler,
            text: "«Коли боєць каже: “Я сам пішов у туалет, і мене ніхто не тримав”, тоді ти розумієш, наскільки важливо те, що ми робимо для них»"
        },
        {
            name: "Юлія Юдіна",
            position: "менторка простору персонального розвитку Колайдер",
            img: Yudina,
            text: "«Сьогодні надзвичайно актуальною стає освіта другої половини життя. Ми бачимо, що люди у 40, 50 і навіть 60 років перебувають у пошуку себе, масштабування свого мислення, своїх проєктів й бізнесу»"
        },
        {
            name: "Юрій Кляцкін",
            position: "засновник Школи Імпровізації Кляцкіна, автор системи розвитку адаптивного інтелекту ",
            img: Klyatskin,
            text: "«Жінки — вроджені майстри емпатії. Вони тонко відчувають, де потрібно натиснути, а де підтримати співробітника, щоб запобігти його вигоранню. З віком чоловіки часто стають менш гнучкими у своїх моделях поведінки, тоді як жінки зберігають високий рівень адаптивності»"
        },
        {
            name: "Владислав Антипов",
            position: "власник та СЕО екологічної компанії ЦЕРН",
            img: Antipov,
            text: "«Жінки краще працюють у режимі мультизадачності та більше фокусуються на емоційному інтелекті та відносинах. Жіночий підхід дає бізнесу необхідну сталість та фокус на стратегічних, ціннісних речах»."
        },
        {
            name: "Сергій Мартинчук",
            position: "генеральний директор Cisco Ukraine",
            img: Martynchuk,
            text: "«Головна сила сучасного бізнесу полягає в нашій різності: у полярності думок, поглядів та інструментів. Гендерний аспект є одним із ключових елементів цієї різноманітності, адже саме поєднання відмінних підходів до дій дозволяє нам бачити повну картину та досягати кращих результатів»"
        },
        {
            name: "Валентина Сахно",
            position: "керівниця KSE Graduate Business School",
            img: Sakhno,
            text: "«У бізнес-школах жінок менше, ніж чоловіків, і часто їх оцінюють за досягнення, а не за потенціал. Багато складних або ризикових проєктів віддають саме їм, бо знають, що вони доведуть справу до кінця, навіть за відсутності ресурсів»"
        },
        {
            name: "Світлана Терещенко",
            position: "засновниця асоціації української культури BORISTENE",
            img: Tereshchenko,
            text: "«Європейці не завжди розуміють наші етнічні коди — вишиванки чи хати-мазанки часто сприймаються ними через призму російської пропаганди як ознака “сільської культури”. Назовні ми маємо нести наше бароко, оперу, класичну музику та балет. Коли вони бачать цей рівень, вони кажуть: “Ви — це ми”. Тоді ми потрапляємо в межі їхньої відповідальності»"
        },
        {
            name: "Влад Іваненко",
            position: "видавець та головний редактор Playboy",
            img: Ivanenko,
            text: "«Ми відійшли від традиційного формату. Наші обкладинки — це про соціальну позицію. Коли ми поставили жінку, яка постраждала від обстрілу, на обкладинку, американський офіс зрозумів: ми не здамося. Тепер ми навіть не платимо за ліцензію, але продовжуємо видавати журнал, частина накладу якого йде безпосередньо військовим на фронт»"
        },
        {
            name: "Антоніна Хижняк",
            position: "акторка кіно, театру та дубляжу, Заслужена артистка України",
            img: Khyzhnyak,
            text: "«В Чілі люди зізнавалися, що ми відкрили їм очі: вони не очікували побачити українців такими розвиненими та сучасними. Особиста розмова про те, як ми живемо без світла, як виховуємо дітей під тривогами, працює сильніше за десять плакатів. Це і є справжній сторітелінг, який торкається сердець»"
        },
    ];

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        adaptiveHeight: true,
    };

    return (
        <section className="relative bg-[#245864]">
            <div className="container max-w-screen-xl mx-auto relative z-30 px-[15px] pt-16 pb-24">

                <div className="flex items-center justify-center gap-4 absolute bottom-9 left-1/2 -translate-x-1/2
                lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 lg:left-0 lg:translate-x-0 lg:justify-between w-full z-10">
                    <button className="p-3 text-white opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickPrev()}>
                        <SlArrowLeft className="text-3xl" />
                    </button>

                    <button className="p-3 text-white opacity-40 hover:opacity-100 transition" onClick={() => sliderRef.current?.slickNext()}>
                        <SlArrowRight className="text-3xl" />
                    </button>
                </div>


                <Slider
                    ref={sliderRef}
                    {...settings}
                    className="[&_.slick-track]:flex [&_.slick-track]:items-start [&_.slick-slide]:h-auto [&_.slick-slide>div]:h-full"
                >
                    {quotesContent.map((item, index) => (
                        <div className="lg:px-12" key={index}>
                            <div className="text-white flex flex-col items-center md:flex-row md:gap-6 lg:gap-10 ">

                                {/* Фото */}
                                <div className="mb-3 md:m-0 lg:w-full lg:max-w-[430px] lg:flex-shrink-0"> 
                                    <img src={item.img} className="w-full" alt={item.name} /> 
                                </div>

                                {/* Текст */}
                                <div>
                                    <h3 className="text-xl font-semibold mb-3 lg:text-3xl">
                                        {item.name}
                                    </h3>

                                    <p className="font-semibold mb-5 lg:text-lg">
                                        {item.position}
                                    </p>

                                    <div className="text-justify lg:text-base">
                                        {item.text}
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
}


export default Quotes